// AppRoutes.js
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import LoginPage from '../screens/Auth/login'
import RegisterPage from '../screens/Auth/register'
import VerifyEmail from '../screens/Auth/register/verify-email'
import ForgotPassword from '../screens/Auth/forgot-password'
import ResetPasswordLink from '../screens/Auth/forgot-password/reset-link'
import ResetPassword from '../screens/Auth/forgot-password/reset-password'
import Onboarding from '../screens/Auth/onboarding'
import WelcomeScreen from 'screens/Auth/onboarding/register-multi-steps/Welcomescreen';
import ConfirmEmail from '../components/ConfirmEmail'
import AddEmployee from '../screens/Auth/onboarding/register-multi-steps/AddEmployee'
import AddCustomer from '../screens/Auth/onboarding/register-multi-steps/AddCustomer'
import AddBulkJobsite from '../screens/Auth/onboarding/register-multi-steps/AddBulkJobsite'
import AddBulkCustomersContact from '../screens/Auth/onboarding/register-multi-steps/AddBulkCustomersContact'
import DashboardPage from '../screens/Dashboard'
import CustomersPage from '../screens/Customers'
import CustomerDetailPage from '../screens/Customers/CustomerDetail'
import EmployeesPage from '../screens/Employees'
import EmployeeDetailPage from '../screens/Employees/EmployeeDetail'
// import EmployeeAddUpdatePage from '../screens/Employees/AddEmployee'
import RequestsPage from '../screens/Requests'
import RequestDetailPage from '../screens/Requests/RequestDetail'
import EmployeeBulkImport from '../screens/Employees/EmployeeBulkImport'

// import CustomerBulkImport from '../screens/Customers/CustomerBulkImport';
// import ContactBulkImport from '../screens/Customers/ContactBulkImport';
// import JobsiteBulkImport from '../screens/Customers/JobsiteBulkImport';
import AssessmentsPage from '../screens/Assessments';
import AssessmentDetailPage from '../screens/Assessments/AssessmentDetail';
import EstimatesPage from '../screens/Estimates';
import EstimateDetailPage from '../screens/Estimates/EstimateDetail';
import WorkOrdersPage from '../screens/WorkOrders';
import WorkOrderDetailPage from '../screens/WorkOrders/WorkOrderDetail';
import DispatchBoardPage from '../screens/DispatchBoard';
import InvoicePage from '../screens/Invoice';
import InvoiceDetailPage from '../screens/Invoice/InvoiceDetail';
import CreateInvoicePage from '../screens/Invoice/component/CreateInvoice';
import PaymentsPage from '../screens/Payments';
import SettingsPage from '../screens/Settings';
import ServicesPage from '../screens/Services';
import InventoryPage from '../screens/Inventory';
import ApprovedPage from 'screens/Estimates/approved';
import RejectedPage from 'screens/Estimates/rejected';
import ReviewPage from 'screens/Estimates/review';
import SetPassword from 'screens/Auth/invite/setPassword';
//Reports Page
import PayrollPage from 'screens/Reports/component/Payroll';
import ReportsPage from 'screens/Reports';
import SalesTaxReport from 'screens/Reports/component/Salestax';
import ServiceandBundleReport from 'screens/Reports/component/ServiceandBundles.js';
import TagsReport from 'screens/Reports/component/Tags';
import TimeClockReport from 'screens/Reports/component/Timeclock';
import LoginActivityReport from 'screens/Reports/component/Loginactivity.js';
// Stripe Checkout Pages
import CheckoutPage from 'screens/Payments/stripe-checkout/checkout';
import SuccessPage from 'screens/Payments/stripe-checkout/success';
import CancelPage from 'screens/Payments/stripe-checkout/cancel';
import ServiceRequestPage from 'screens/Requests/RequestEmbedable';

// Stripe Connect Pages

import StripeConnectSuccess from 'components/StripeConnect/connect-success';
import CustomerSuccessPage from 'screens/Payments/stripe-checkout/CustomerSuccess';

// ServiceAssetAndMaterialUpload
import AddService from '../screens/Auth/onboarding/register-multi-steps/AddService/index.js';
import AddAsset from '../screens/Auth/onboarding/register-multi-steps/AddAsset/index.js';
import AddMaterial from '../screens/Auth/onboarding/register-multi-steps/AddMaterial/index.js';

//SuperAdmin Screens
import UserDeletionPage from 'screens/SuperAdminScreen/DeleteUser';
import MySQLEditor from 'screens/SuperAdminScreen/MySQLEditor';


import PrivateRoute from './PrivateRoute';
import PaymentPage from 'screens/Payments/payment-page';

import QuickbooksPage from 'screens/Quickbooks/Component/Dashboard';
import FinancialMappingPage from 'screens/Quickbooks/Component/Financialmapping';
import InventoryManagement from 'screens/Quickbooks/Component/Inventory';
import QuickbooksPaymentPage from 'screens/Quickbooks/Component/Payments';
import RefundsPage from 'screens/Quickbooks/Component/Refunds';
import CustomerAndJobsites from 'screens/Quickbooks/Component/CustomerandJobsites';
import EmployeeListPage from 'screens/Quickbooks/Component/Employees';
import QuickBooksCallback from 'screens/Quickbooks/QuickBooksCallBack'; 
import QuickBooksSuccess from 'screens/Quickbooks/Success'; 
import QuickbookInvoicePage from 'screens/Quickbooks/Component/Invoice';
import QuickbooksServicePage from 'screens/Quickbooks/Component/Services';
import QuickbooksTaxPage from 'screens/Quickbooks/Component/Taxes';
import QuickbooksErrorPage from 'screens/Quickbooks/Component/FixErrors';
import FeatureBaseProvider from "components/feature-base/featureBase";
const PreviewInvoice = () => {
  window.location.href = '/Cleri_PreviewInvoice/index.html'
  return null;
}

const AppRoutes = () => {

  function RequestDetailPageWrapper() {
    const { requestID } = useParams();
    return <RequestDetailPage key={requestID} />;
  }

  function AssessmentDetailPageWrapper() {
    const { requestID } = useParams();
    return <AssessmentDetailPage key={requestID} />;
  }

  // function EstimateDetailPageWrapper() {
  //   const { requestID } = useParams();
  //   return <EstimateDetailPage key={requestID} />;
  // }
  
  return (
    <Routes>
      {/* Public Routes */}
      
      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-link" element={<ResetPasswordLink />} />
      <Route path="/resetpasswordconfirm" element={<ResetPassword />} />
      <Route path="/confirmemail" element={<ConfirmEmail />} />
      
      <Route path="/estimate/approved" element={ <ApprovedPage />} />
      <Route path="/estimate/rejected" element={ <RejectedPage />} />
      <Route path="/estimate/review" element={ <ReviewPage />} />
      <Route path="/set-password" element={ <SetPassword />} />
      <Route path="/Payments/checkout" element={ <CheckoutPage />} />
      <Route path="/subscription/success" element={ <SuccessPage />} />
      <Route path="/subscription/cancel" element={ <CancelPage />} />

      <Route path="/stripe-connect/success" element={ <StripeConnectSuccess />} />
      <Route path="/CustomerPayment/success" element={ <CustomerSuccessPage />} />
      
      {/* Preview Invoice Page */}
      <Route path="/preview-invoice" element={<PreviewInvoice />} />
      <Route path="/payment/paynow" element={<PaymentPage/>} />
      {/* ServiceAssetAndMaterial Upload */}

      <Route path ="/request/create/:token" element={<ServiceRequestPage />} />      

      {/* Private Routes */}
      <Route element={<PrivateRoute/>}>        
        <Route path="/dashboard" element={<DashboardPage /> }/>
        <Route path="/customers" element={<CustomersPage />}/>  

        <Route path='/welcome' element={<WelcomeScreen />} />
        <Route path="/onboarding/upload-service" element={ <AddService />} />
        <Route path="/onboarding/upload-asset" element={ <AddAsset />} />
        <Route path="/onboarding/upload-material" element={ <AddMaterial />} />
        <Route path="/onboarding" element={ <Onboarding />} />
        <Route path="/onboarding/add-employee" element={ <AddEmployee />} />
        <Route path="/onboarding/add-customer" element={ <AddCustomer />} />
        <Route path="/onboarding/add-customer-with-jobsites" element={ <AddBulkJobsite />} />
        <Route path="/onboarding/add-customer-with-contacts" element={ <AddBulkCustomersContact />} />        
        <Route path ="/quickbooks/callback" element={<QuickBooksCallback />} />
        <Route path="/quickbooks/success" element={<QuickBooksSuccess />} />
{/* 
        <Route
          path="/customers/add-bulk-jobsites"
          element={
            <JobsiteBulkImport />
          }
        /> */}
        <Route
          path="/customers/detail/:customerID"
          element={
            <CustomerDetailPage />
          }
        />
        <Route
          path="/employees"
          element={
            <EmployeesPage />
          }
        />
        <Route
          path="/employees/detail/:employeeID"
          element={
            <EmployeeDetailPage />
          }
        />
        <Route
          path="/employees/add-bulk-employees"
          element={
            <EmployeeBulkImport />
          }
        />
        {/* <Route
        path="/employees/create"
        element={ 
            <EmployeeAddUpdatePage /> 
        }
      /> */}
        <Route
          path="/requests"
          element={
            <RequestsPage />
          }
        />
        <Route
          path="/requests/detail/:requestID"
          element={<RequestDetailPageWrapper />}
        />



        <Route
          path="/assessments"
          element={
            <AssessmentsPage />
          }
        />

        {/* <Route
        path="/assessments/detail/:requestID"
        element={ 
            <AssessmentDetailPage /> 
        }
      /> */}

        <Route
          path="/assessments/detail/:requestID"
          element={<AssessmentDetailPageWrapper />}
        />

        <Route
          path="/estimates"
          element={
            <EstimatesPage />
          }
        />

        <Route
          path="/estimates/detail/:requestID"
          element={
            <EstimateDetailPage />
          }
        />

        <Route
          path="/work-orders"
          element={
            <WorkOrdersPage />
          }
        />

        <Route
          path="/work-orders/detail/:requestID"
          element={
            <WorkOrderDetailPage />
          }
        />

        <Route
          path='/dispatch-board'
          element={
            <DispatchBoardPage />
          }
        />

        <Route
          path="/invoices"
          element={
            <InvoicePage />
          }
        />

        <Route
          path="/invoices/create"
          element={
            <CreateInvoicePage />
          }
        />

        <Route
          path="/invoices/detail/:invoiceID"
          element={
            <InvoiceDetailPage />
          }
        />

        <Route
          path="/payments"
          element={
            <PaymentsPage />
          }
        />
       <Route
         path="/reports"
         element={
         <ReportsPage />
        }
       />
       <Route
       path='/reports/payroll'
       element={
         <PayrollPage />
       }
       />
        <Route
        path='/reports/salestax'
       element={
         <SalesTaxReport />
       }
       />
       <Route
       path='/reports/serviceandbundles'
       element={
        <ServiceandBundleReport />
       }
        />
        <Route
          path="/reports/tags"
          element={
            <TagsReport />
          }
        />
        <Route
        path='/reports/timeclock'
          element={
            <TimeClockReport />
          }
        />
        <Route
        path="/reports/loginactivity"
          element={
            <LoginActivityReport />
          }
        />
        <Route
          path="/settings"
          element={
            <SettingsPage />
          }
        />

        <Route
          path="/services"
          element={
            <ServicesPage />
          }
        />

        <Route
          path="/inventory"
          element={
            <InventoryPage />
          }
        />
        <Route
        path= '/quickbooks/synclogs'
        element = {<QuickbooksErrorPage />}
        />
        <Route
        path='/quickbooks/taxes'
          element={<QuickbooksTaxPage />}
        />
        <Route
        path='/quickbooks/services'
        element={<QuickbooksServicePage />}
        />
       <Route
       path='/quickbooks/customer&jobsites'
       element={<CustomerAndJobsites />}
       />

       <Route
        path='/quickbooks/invoices'
        element={<QuickbookInvoicePage />}
        />
       <Route
        path='/quickbooks/employees'
        element={<EmployeeListPage />}
        />
        <Route
        path='/quickbooks/refunds'
        element={<RefundsPage />}
        />
        <Route 
          path ="/quickbooks/financialmapping"
          element={
          <FinancialMappingPage />
          }
        />
         <Route 
        path="/quickbooks/inventory"
        element={<InventoryManagement />}
        />
        <Route
        path='/quickbooks/payments'
        element={<QuickbooksPaymentPage />}
        />
        <Route
        path="/quickbooks"
        element={<QuickbooksPage />}
        />

        
        <Route path="/superadmin/deleteuser" element={<UserDeletionPage />} />
        <Route path="/superadmin/database" element={<MySQLEditor />} />
        
        {/* Catch empty route */}
        <Route
          path="/"
          element={<Navigate to="/dashboard" />}
        />

        {/* Catch-all Route */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
        
      </Route>
       
      
      {/* <Route
        path="/customers/add-bulk-customers"
        element={ 
            <CustomerBulkImport /> 
        }
      /> */}
      {/* <Route
        path="/customers/add-bulk-contacts"
        element={ 
            <ContactBulkImport /> 
        }
      /> */}
      
    </Routes>
  );
};

export default AppRoutes;